var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiletypePlaceholderReceiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.511,
    height: 36.511,
    viewBox: "0 0 36.511 36.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15378",
    "data-name": "Group 15378",
    transform: "translate(-151 -763.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15232",
    "data-name": "Group 15232",
    transform: "translate(120 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15229",
    "data-name": "Group 15229",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15227",
    "data-name": "Group 15227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(31 760.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9780",
    "data-name": "Path 9780",
    d: "M36.511,30.795a5.716,5.716,0,0,1-5.716,5.716H5.716A5.716,5.716,0,0,1,0,30.795V7.431L7.431,0H30.795a5.716,5.716,0,0,1,5.716,5.716Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9782",
    "data-name": "Path 9782",
    d: "M0,7.431H4.954A2.468,2.468,0,0,0,7.431,4.973V0Z",
    fill: "#747474"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_324_",
    transform: "translate(159.951 769.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_331_",
    d: "M127.539,66.144H115.072a.472.472,0,1,1,0-.944h12.467a.472.472,0,1,1,0,.944Z",
    transform: "translate(-114.6 -65.2)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_330_",
    d: "M127.539,98.144H115.072a.472.472,0,1,1,0-.944h12.467a.472.472,0,1,1,0,.944Z",
    transform: "translate(-114.6 -93.154)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_329_",
    d: "M134.709,130.044H115.086a.472.472,0,1,1,0-.944h19.623a.472.472,0,1,1,0,.944Z",
    transform: "translate(-114.6 -121.021)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_328_",
    d: "M134.709,162.044H115.086a.472.472,0,1,1,0-.944h19.623a.472.472,0,1,1,0,.944Z",
    transform: "translate(-114.6 -148.975)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_327_",
    d: "M134.709,194.044H115.086a.472.472,0,1,1,0-.944h19.623a.472.472,0,1,1,0,.944Z",
    transform: "translate(-114.6 -176.929)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_326_",
    d: "M134.709,225.944H115.086a.472.472,0,1,1,0-.944h19.623a.472.472,0,1,1,0,.944Z",
    transform: "translate(-114.6 -204.795)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_325_",
    d: "M134.709,257.944H115.086a.472.472,0,1,1,0-.944h19.623a.472.472,0,1,1,0,.944Z",
    transform: "translate(-114.6 -232.749)",
    fill: "#747474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletypePlaceholderReceiver);
export default __webpack_public_path__ + "static/media/filetype-placeholderReceiver.436f135a.svg";
export { ForwardRef as ReactComponent };